import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export function DocumentRelationValidator(): ValidatorFn {
  return (formArray: FormArray): ValidationErrors | null => {
    return formArray.controls.some((control) => control.hasError('required'))
      ? { completeDocRelations: true }
      : null;
  };
}
